import React from 'react';
import {
  AboutContainer,
  AboutHeader,
  AboutPage,
  AboutText,
  AboutList,
  AboutListItem,
} from './AboutSectionElements';
import { useLanguage } from '../../../hooks';
import { MainPageText } from '../../Library/LibraryMainPage';

const AboutSection = () => {
  const { lang } = useLanguage();
  return (
    <AboutPage id="about">
      <AboutContainer>
        <AboutHeader>{MainPageText[lang].secondTitle}</AboutHeader>
        <AboutText>
          {MainPageText[lang].secondAbout}
          <AboutList>
            {MainPageText[lang].secondAboutList.map((item, index) => (
              <AboutListItem key={index}>{item}</AboutListItem>
            ))}
          </AboutList>
          <p>{MainPageText[lang].secondAboutFooter}</p>
        </AboutText>
      </AboutContainer>
    </AboutPage>
  );
};

export default AboutSection;
